/* eslint-disable @typescript-eslint/no-this-alias */
import * as THREE from 'three';
import _font from '../../assets/jsons/Roboto_Regular.json';
import BasicObject from './BasicObject';

export class TextObject extends BasicObject {
  private offsetY = 0.01;
  text = '';
  material = new THREE.MeshBasicMaterial({ color: 0x000000 });
  offsetWidth = 0;
  offsetHeight = 0;
  sizeFont = 0.09;
  constructor(text: string, sizeFont?: number) {
    super();
    this.text = text;
    this.type = 'text_point';
    this.name = 'text_point';
    if (sizeFont) {
      this.sizeFont = sizeFont;
    }

    this.buildGeometry();
  }

  buildGeometry() {
    // const self = this;
    if (this.geometry) {
      this.geometry.dispose();
    }
    const font = new THREE.Font(_font);
    const shapes = font.generateShapes(this.text, this.sizeFont);
    this.geometry = new THREE.ShapeBufferGeometry(shapes);
    this.geometry.applyMatrix4(new THREE.Matrix4().makeRotationX(-Math.PI / 2));
    this.setCenterPosition();
  }
  rebuildGeometry() {
    this.geometry.dispose();
    const font = new THREE.Font(_font);
    const shapes = font.generateShapes(this.text, this.sizeFont);
    this.geometry = new THREE.ShapeBufferGeometry(shapes);
    this.geometry.applyMatrix4(new THREE.Matrix4().makeRotationX(-Math.PI / 2));
  }
  setStartPosition(direction?: THREE.Vector3) {
    if (this.geometry.boundingBox?.min && this.geometry.boundingBox?.max) {
      const superPoint = new THREE.Vector3(
        this.geometry.boundingBox.max.x,
        this.geometry.boundingBox.min.y,
        this.geometry.boundingBox.min.z
      );
      this.offsetWidth = superPoint.distanceTo(this.geometry.boundingBox.min) / 2;
      this.offsetHeight = superPoint.distanceTo(this.geometry.boundingBox.max) / 2;

      if (direction) {
        this.position.add(direction.clone().multiplyScalar(-this.offsetWidth));
      }
      this.position.y += this.offsetY;
    }
  }
  setCenterPosition() {
    this.geometry.computeBoundingBox();
    if (this.geometry.boundingBox?.min && this.geometry.boundingBox?.max) {
      const superPoint = new THREE.Vector3(
        this.geometry.boundingBox.max.x,
        this.geometry.boundingBox.min.y,
        this.geometry.boundingBox.min.z
      );
      this.offsetWidth = superPoint.distanceTo(this.geometry.boundingBox.min) / 2;
      this.offsetHeight = superPoint.distanceTo(this.geometry.boundingBox.max) / 2;

      this.geometry.applyMatrix4(
        new THREE.Matrix4().makeTranslation(
          this.position.x - this.offsetWidth,
          this.position.y,
          this.position.z + this.offsetHeight
        )
      );
    }
  }
  setPosition(position: THREE.Vector3, direction?: THREE.Vector3) {
    this.position.copy(position);
    if (direction) {
      this.position.add(direction.clone().multiplyScalar(-this.offsetWidth));
    }
    this.position.y += this.offsetY;
  }
  removeMesh() {
    super.removeMesh(this);
  }
}
